import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router";
import api from "../../services/api"
import { Toast } from '../../shared/Toast'
import { toast } from "react-toastify";
import { roles, updateBlockerFlag } from "../../utils/constants";
import { daysBetween, NEWISODateString, SameDay, formatDateWithTime, DatetoTimestamp, End_date_cpd, getEnd_date_limit_for_CPD } from "../../utils/dateFormat";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";
import PreviewFrameEdit from "../PreviewFrameEdit";
import Stepper from 'react-stepper-horizontal';
import { SlButton } from '@shoelace-style/shoelace/dist/react';
import config from "../../config.js";


export const campCreativeContext3 = React.createContext();

function Date() {

    const steps = [
        { title: 'LineItem' },
        { title: 'Targets' },
        { title: 'Dates & Budget' },
        { title: 'Creative Selection' },

    ];

    const location = useLocation()
    const navigate = useNavigate()
    let order = location.state.order

    let [datelist, setDatelist] = useState([])
    const [currentDate, setCurrentDate] = useState("");
    const [sameday, setSameday] = useState(false)
    const [plusdisable, setPlusdisable] = useState(true)
    const [discoutnEnab, setDiscountEnab] = useState(false)

    const temp_start = location.state?.date?.start
    const type = location.state.type
    const isBrandAd = location.state.isBrandAd
    const ro_number = location.state.start.ro_number;
    const typeofcamp = location.state.start.campaign_type
    useEffect(() => {
        if (localStorage.getItem("role") !== roles.ops)
            navigate("/pagenotfound")
        if (location.state.date)
            editaction()
        else if(location?.state?.prefillingData?.date)
            prefilling()
        TimeChecker()
    }, [])

    const editaction = () => {
        const date = location.state.date;
        const budget = location.state.budget;
        formik.setFieldValue("start", date.start)
        formik.setFieldValue("ser_24_hrs", date.ser_24_hrs || false)
        formik.setFieldValue("start_date", date.start_date)
        formik.setFieldValue("end_date", date.end_date)
        formik.values.start =  date.start
        formik.values.ser_24_hrs =  date.ser_24_hrs || false
        formik.values.start_date =  date.start_date
        formik.values.end_date =  date.end_date
        if (typeofcamp === "CPD")
        {
            formik.setFieldValue("total_budget", 0)
            formik.setFieldValue("daily_budget", 0)
            formik.setFieldValue("cpm", 0)
            formik.setFieldValue("cpc_price", 0)
            formik.setFieldValue("tot_click_cap",0)
            formik.setFieldValue("tot_imp_cap",0)
            formik.setFieldValue("daily_click_cap",0)
            formik.setFieldValue("daily_imp_cap",0)
        }
        else{
            formik.setFieldValue("total_budget", budget.total_budget)
            formik.setFieldValue("daily_budget", budget.daily_budget)
            formik.values.total_budget = budget.total_budget
            formik.values.daily_budget = budget.daily_budget
            formik.setFieldValue("cpm", budget.cpm)
            formik.values.cpm = budget.cpm
            formik.setFieldValue("cpc_price", budget.cpc_price)
            formik.values.cpc_price = budget.cpc_price

            if(typeofcamp === "CPM" && +budget.cpm !== config.ACTUALCPM)
                setDiscountEnab(true)
            if(typeofcamp === "CPC" && +budget.cpc_price !== config.ACTUALCPC)
                setDiscountEnab(true)
        }
        if (date.datelist.length > 0) {
            setCheck(!check)
            setDatelist(date.datelist)
            if (date.datelist.length < 2) {
                setPlusdisable(location.state.plusdisable ? location.state.plusdisable : false)
                setSameday(location.state.sameday ? location.state.sameday : false)
            }
        }
        if(typeofcamp === "CPM"){
            formik.setFieldValue("cpc_price", 0)
            formik.setFieldValue("tot_click_cap",0)
            formik.setFieldValue("daily_click_cap",0)
        }
        if(typeofcamp === "CPC"){
            formik.setFieldValue("cpm", 0)
            formik.setFieldValue("tot_imp_cap", 0)
            formik.setFieldValue("daily_imp_cap", 0)
        }
        if(typeofcamp === "CPC" || typeofcamp === "CPM" )
            DailyBudgetCalculation(+budget.total_budget)           

    }
    const prefilling = async () => {
        const date = location.state.prefillingData.date;
        const budget = location.state.prefillingData.budget;
        formik.setFieldValue("start_date", date.start_date)
        formik.setFieldValue("end_date", date.end_date)
        formik.values.start_date =  date.start_date
        formik.values.end_date =  date.end_date
        if (typeofcamp === "CPD")
        {
            formik.setFieldValue("total_budget", 0)
            formik.setFieldValue("daily_budget", 0)
            formik.setFieldValue("cpm", 0)
            formik.setFieldValue("cpc_price", 0)
            formik.setFieldValue("tot_click_cap",0)
            formik.setFieldValue("tot_imp_cap",0)
            formik.setFieldValue("daily_click_cap",0)
            formik.setFieldValue("daily_imp_cap",0)
        }
        else{
            formik.setFieldValue("total_budget", budget.total_budget)
            formik.setFieldValue("daily_budget", budget.daily_budget)
            formik.values.total_budget = budget.total_budget
            formik.values.daily_budget = budget.daily_budget
            formik.setFieldValue("cpm", budget.cpm)
            formik.values.cpm = budget.cpm
            if(typeofcamp === "CPM" && +budget.cpm !== config.ACTUALCPM)
                setDiscountEnab(true)

        }
        if (date.datelist.length > 0) {
            setCheck(!check)
            setDatelist(date.datelist)
            if (date.datelist.length < 2) {
                setPlusdisable(location.state.plusdisable ? location.state.plusdisable : false)
                setSameday(location.state.sameday ? location.state.sameday : false)
            }
        }
        if(typeofcamp === "CPM"){
            formik.setFieldValue("cpc_price", 0)
            formik.setFieldValue("tot_click_cap",0)
            formik.setFieldValue("daily_click_cap",0)
        }
        if(typeofcamp === "CPM" )
            DailyBudgetCalculation(+budget.total_budget)           

    }

    const checker = (check) => {
        if(isBrandAd){
            if((check === "start_date") && (typeofcamp === "CPD"))
                return Yup.date().required("Start Date is reqired")
            else if ((check === "end_date") && (typeofcamp === "CPD"))
                return Yup.date().required("End Date is required").min(
                Yup.ref('start_date'),
                "End date can't be before Start date"
                )
                else if ((check === "start") && (typeofcamp === "CPD")) {
                    return Yup.date()
                }            
        }

        if (check === "daily_budget" && (typeofcamp !== "CPD"))
            return Yup.number().required("Daily Budget is Required").min(0.1, "Daily budget should be greater than 0").max(Yup.ref('total_budget'), "Daily Budget Should Be Less Than Total Budget")
        else if ((check === "start_date") && (typeofcamp !== "CPD")) {
            return Yup.date().required("Start Date is reqired")
        }
        else if ((check === "end_date") && (typeofcamp !== "CPD")) {
            return Yup.date().required("End Date is required").min(
                Yup.ref('start_date'),
                "End date can't be before Start date"
            )
        }

        else if (check === "daily_budget" && (typeofcamp === "CPD")) {
            return Yup.number()
        }
        else if ((check === "cpc_price") && (typeofcamp === "CPC")) {
            return Yup.number().required("CPC Price is required").min(0, 'CPC price should be greater than or equal to 0')
        }
        else if ((check === "cpc_price") && typeofcamp !== "CPC") {
            return null
        }
        else if (check === "cpm_price" && typeofcamp === "CPM") {
            return Yup.number().required("CPM Price is required").min(0, 'CPM price should be greater than or equal than 0')
        }
        else if (check === "tot_imp_cap") {
            return Yup.number().min(0, "Must be greater than or equal to 0")
        }
        else if (check === "daily_imp_cap") {
            return Yup.number().min(0, "Must be greater than or equal to 0").max(Yup.ref('tot_imp_cap'), "Daily Impression Cap Should Be Less Than Total Impression Cap")
        }
        else if (check === "tot_click_cap") {
            return Yup.number().min(0, "Must be greater than or equal to 0")
        }
        else if (check === "daily_click_cap") {
            return Yup.number().min(0, "Must be greater than or equal to 0").max(Yup.ref('tot_click_cap'), "Daily Click Cap Should Be Less Than Total Click Cap")
        }
        else if ((check === "total_budget") && (typeofcamp !== "CPD")) {
            return Yup.number().min(1, 'Should be greater than 0').required("Total Budget is required ")
        }
        else if ((check === "start") && (typeofcamp === "CPD")) {
            return Yup.date().required("Start Date is Required")
        }
        else if ((check === "start") && (typeofcamp !== "CPD")) {
            return Yup.date()
        }
        else if ((check === "start_date") && (typeofcamp === "CPD")) {
            return Yup.date()
        }
        else if ((check === "end_date") && (typeofcamp === "CPD")) {
            return Yup.date()
        }
        else
            return Yup.number()
    }

    const formik = useFormik({
        initialValues: {
            start_date: "",
            end_date: "",
            start: "",
            ser_24_hrs: false,
            total_budget: 0,
            daily_budget: 0,
            cpm: typeofcamp === "CPM" ? +config.ACTUALCPM : 0,
            tot_imp_cap: 0,
            tot_click_cap: 0,
            daily_imp_cap: 0,
            daily_click_cap: 0,
            cpc_price: typeofcamp === "CPC" ? +config.ACTUALCPC : 0,
        },
        validationSchema: Yup.object({
            start: checker("start"),
            ser_24_hrs: Yup.boolean(),
            start_date: checker("start_date"),
            end_date: checker("end_date"),
            total_budget: checker("total_budget"),
            daily_budget: checker("daily_budget"),
            cpm: checker("cpm_price"),
            tot_imp_cap: checker("tot_imp_cap"),
            tot_click_cap: checker("tot_click_cap"),
            daily_imp_cap: checker("daily_imp_cap"),
            daily_click_cap: checker("daily_click_cap"),
            cpc_price: checker("cpc_price"),
        }),
        onSubmit: async (values) => {
            // if (location.state.start.campaign_type !== "CPD") {
            //     try {
            //         let req_data = {order_id: order.order_id}
            //         if(location?.state?.action === 'edit'){
            //             req_data.campaign_id = location?.state?.id
            //         }
            //         let res = await api({
            //             url: '/order/getOrdervalue',
            //             method: 'POST',
            //             responseType: 'json',
            //             data: req_data
            //         })
            //         if (res.code === 200) {
            //             if (res.data.total < +values.total_budget) {
            //                 Toast('error', `RO balance is ${res.data.total - res.data.spent}`)
            //                 return
            //             }
            //             if ((res.data.total - res.data.spent) <= 0) {
            //                 Toast('error', `RO balance is ${res.data.total - res.data.spent}`)
            //                 return
            //             }
            //             if ((values.total_budget + res.data.spent) > res.data.total) {
            //                 Toast('error', `RO balance is ${res.data.total - res.data.spent}`)
            //                 return
            //             }
            //         }
            //         else {
            //             return
            //         }

            //     } catch (error) {
            //         console.error(error);
            //         if (error.response.status === 401)
            //             navigate("/")
            //     }
            // }
                let flag = 0;
                switch (location.state.start.campaign_type) {
                    case "CPC":
                        values.cpm = 0
                        values.tot_imp_cap = 0
                        values.daily_imp_cap = 0
                        break
                    case "CPM":
                        values.cpc_price = 0
                        values.tot_click_cap = 0
                        values.daily_click_cap = 0
                        break
                    default:
                        if(isBrandAd){
                            values.start = ""
                        }
                        else{
                            values.start_date = ""
                            values.end_date = ""
                        }
                        values.total_budget = 0
                        values.daily_budget = 0
                        values.cpc_price = 0
                        values.cpm = 0
                        values.tot_click_cap = 0
                        values.daily_click_cap = 0
                        values.tot_imp_cap = 0
                        values.daily_imp_cap = 0
                        setDatelist([])
                        datelist = [];

                }
                const dateResult = { start_date: formik.values.start_date, end_date: formik.values.end_date, start: formik.values.start, datelist: datelist, ser_24_hrs: formik.values.ser_24_hrs }
                if (check === true) {
                    if (datelist.length === 0 && location.state.start.campaign_type !== "CPD") {
                        flag = 1
                    }
                    datelist.map((item, i) => (

                        datelist[i].sdate === '' || datelist[i].edate === '' || (datelist[i].sdate >= datelist[i].edate) ?
                            flag = 1
                            : null
                    )
                    )

                }
                else {
                    if (values.start_date === values.end_date && (typeofcamp !== "CPD")) {
                        flag = 1
                    }
                }
                if (flag === 1) {
                    Toast('error', 'Date Fields Are Not Valid')
                }
                if (flag === 0) {
                    const date_budget_preview = { ...values, datelist, till_date: sameday && !plusdisable }
                    let discount_obj = null
                    if(typeofcamp === "CPC" && +values.cpc_price !== +config.ACTUALCPC && (+config.ACTUALCPC - +values.cpc_price) > 0){
                        discount_obj = {discount_no : Math.abs((100/config.ACTUALCPC)*(config.ACTUALCPC - +values.cpc_price)).toFixed(2), actualPrice: config.ACTUALCPC, discountPrice: +values.cpc_price,  discsign: (config.ACTUALCPC - +values.cpc_price) > 0 ? false: true}
                    }
                    if(typeofcamp === "CPM" && +values.cpm !== +config.ACTUALCPM && (+config.ACTUALCPM - +values.cpm) > 0){
                        discount_obj = {discount_no : Math.abs((100/config.ACTUALCPM)*(config.ACTUALCPM - +values.cpm)).toFixed(2), actualPrice: config.ACTUALCPM, discountPrice: +values.cpm,  discsign: (config.ACTUALCPM - +values.cpm) > 0 ? false: true}
                    }
                    navigate("/home/campaign/creatselect", { state: { ...location.state, date: dateResult, budget: values, sameday: sameday, plusdisable: plusdisable, date_budget_preview: date_budget_preview, discount_obj } })
                }
            
        }
    });

    const DailyBudgetCalculation = (total) => {
        let Number_of_days = daysBetween(formik.values.start_date, formik.values.end_date, datelist);

        if (Number_of_days <= 0 || isNaN(Number_of_days) || total <= 0 || total === "") {
            formik.values.daily_budget = 0
            return
        }
        formik.values.total_budget = total;
        formik.values.daily_budget = (total / Number_of_days).toFixed(2);
        if (typeofcamp === "CPM") {
            let cpm = 0;
            if(+formik.values.cpm === 0)
                cpm = +config.ACTUALCPM
            else
                cpm = +formik.values.cpm
            formik.setFieldValue("tot_imp_cap", parseInt((total * 1000) / cpm));
            formik.values.tot_imp_cap = parseInt((total * 1000) / cpm)
            formik.values.daily_imp_cap = parseInt((formik.values.daily_budget * 1000) / cpm)
            formik.setFieldValue("daily_imp_cap", parseInt((formik.values.daily_budget * 1000) / cpm))
        }
        if (typeofcamp === "CPC") {
            let cpc_price = 0;
            if(+formik.values.cpc_price === 0)
                cpc_price = config.ACTUALCPC
            else
                cpc_price = formik.values.cpc_price
            formik.values.tot_click_cap = parseInt(formik.values.total_budget / cpc_price)
            formik.values.daily_click_cap = parseInt(formik.values.daily_budget / cpc_price)
            formik.setFieldValue("tot_click_cap", parseInt(formik.values.total_budget / cpc_price))
            formik.setFieldValue("daily_click_cap", parseInt(formik.values.daily_budget / cpc_price))
        }
    }


    const [check, setCheck] = useState(0)

    function handleClick() {
        setDatelist([...datelist, { sdate: "", edate: "", sderror: '', ederror: '' }])
    }
    function handleDateChange(e, index) {
        const { name, value } = e.target
        const list = [...datelist]
        list[index][name] = value
        setDatelist(list)
    }

    const [derror, setDerror] = useState(false)
    const [derror1, setDerror1] = useState(false)
    const handleRemove = (index) => {
        const list = [...datelist]
        list.splice(index, 1);
        setDatelist(list)
    }

    useEffect(() => {
        setDerror(derror)
        setDerror1(derror1)

    }, [derror, derror1])
    useEffect(() => {
        DailyBudgetCalculation(formik.values.total_budget)
    }, [datelist])

    const TimeChecker = () => {
        setCurrentDate(NEWISODateString())
    }

    const CheckDate = (index) => {
        if ((datelist[index].sdate <= formik.values.start_date) || (datelist[index].sdate >= formik.values.end_date) || (datelist[index].sdate === '')) {
            setDerror(true)
            datelist[index].sderror = 'This Date is Incorrect'
            return
        }
        if ((datelist[index].edate <= formik.values.start_date) || (datelist[index].edate >= formik.values.end_date) || (datelist[index].edate === '') || (datelist[index].edate <= datelist[index].sdate)) {
            setDerror1(true)
            datelist[index].ederror = 'This Date is Incorrect'
            return
        }
        else {
            setDerror(false)
            setDerror1(false)
            datelist[index].sderror = ''
            datelist[index].ederror = ''
        }
        for (let i = index - 1; i >= 0; i--) {
            if ((datelist[index].sdate <= datelist[i].sdate) && (datelist[index].edate >= datelist[i].sdate)) {
                setDerror1(true)
                datelist[index].ederror = 'This Date is Incorrect'
            }
            if (datelist[index].edate < datelist[index].sdate) {
                setDerror1(true)
                datelist[index].ederror = 'This Date is Incorrect'
            }

            if ((datelist[index].sdate >= datelist[i].sdate) && (datelist[index].sdate <= datelist[i].edate)) {
                setDerror(true)
                datelist[index].sderror = 'This Date is Incorrect'
                return
            }
            if ((datelist[index].sdate <= datelist[i].sdate) && (datelist[index].edate >= datelist[i].sdate)) {
                setDerror(true)
                datelist[index].sderror = 'This Date is Incorrect'
                return
            }
            if ((datelist[index] !== '') && (datelist[index] !== '')) {
                if ((datelist[index].sdate <= datelist[i].sdate) && (datelist[index].edate >= datelist[i].edate)) {
                    setDerror(true)
                    datelist[index].sderror = 'This Date is Incorrect'
                    return
                }
                if ((datelist[index].sdate <= datelist[i].sdate) && (datelist[index].edate >= datelist[i].edate)) {
                    setDerror1(true)
                    datelist[index].ederror = 'This Date is Incorrect'
                    return
                }
                if ((datelist[i].sdate <= datelist[index].sdate) && (datelist[index].edate <= datelist[i].edate)) {
                    setDerror1(true)
                    datelist[index].ederror = 'This Date is Incorrect'
                    return
                }
                if ((datelist[i].sdate <= datelist[index].sdate) && (datelist[index].edate <= datelist[i].edate) && (datelist[index].edate !== '')) {

                    setDerror(true)
                    datelist[index].sderror = 'This Date is Incorrect'
                    return
                }
                if ((datelist[index].sdate > datelist[i].edate) && (datelist[index].edate <= formik.values.end_date)) {
                    setDerror(false)
                    datelist[index].sderror = ''
                    return
                }
                if (datelist[index].sdate >= datelist[index].edate) {
                    setDerror(true)
                    datelist[index].sderror = 'This Date is Not Valid'
                    return
                }
                if ((datelist[index].sdate >= datelist[i].sdate) && (datelist[index].sdate <= datelist[i].edate)) {

                    setDerror(true)
                    datelist[index].sderror = 'This Date is Not Valid'
                    return
                }
            }
            else {
                setDerror1(false)
                datelist[index].ederror = ''
                setDerror(false)
                datelist[index].sderror = ''
            }
        }
    }

    return (<>
        <div className="campaign-drawer">
            <div className='title'>
                <legend>Create LineItem</legend>
                <sl-icon name="x" type="button" className="text-danger mt-2" style={{ right: 20, position: "absolute" }} onClick={() => { if(location.state.action === "edit" && (location.state?.status === 5 || location?.state?.status === 2)){updateBlockerFlag(location.state.id, false);}  navigate(`/home/order/${order.id}`, {state:{order}}) }}></sl-icon>
            </div>
            <div className={window.innerWidth <= 767 ? "" : "grid grid-cols-2 divide-x mt-3"}>
            <div className="mobHide">
                    <section className="flex gap-6">
                        <div className="basis-7/12 grid gap-6 grid-cols-2">
                            {location.state.start_preview && <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6 className="mb-2">LineItem Creation</h6>
                                {location.state.start_preview.campaign_name && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">LineItem Name : </label>
                                    <span>{location.state.start_preview.campaign_name}</span>
                                </div>}
                                {location.state.start_preview.campaign_type && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">LineItem Type : </label>
                                    <span>{location.state.start_preview.campaign_type}</span>
                                </div>}
                                {location.state.start_preview.campaign_type && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Type : </label>
                                    <span>{location.state.type}</span>
                                </div>}
                                {location.state.start_preview.brand && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Brand : </label>
                                    <span>{location.state.start_preview.brand_id}</span>
                                </div>}
                            </section>}

                            {location.state.target_preview && <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6 className="mb-2">Target</h6>
                                {(Array.isArray(location.state?.target_preview?.lang_ids) && location.state.target_preview?.lang_ids?.length > 0) && <div className="flex justify-between mb-2"><label className="text-slate-500">Languages :</label> </div>}
                                {location.state.target_preview?.lang_ids?.map((item, i) => {
                                    return item
                                })}
                                {(Array.isArray(location.state.target_preview?.zone_ids) && location.state.target_preview?.zone_ids?.length > 0) && <div>
                                {<label className="text-slate-500">Zones : </label>}
                                <b>{location.state.target_preview?.zone_ids?.map((item) => {
                                    return item
                                }
                                )}</b>
                                </div>}
                                {!location.state.target_preview?.zone_ids?.length ? <>
                                {((Array.isArray(location.state.target_preview?.state_ids) && location.state.target_preview.state_ids?.length > 0) && <div>
                                    <label className="text-slate-500">States : </label>
                                    <b>{location.state.target_preview.state_ids.map((item, i) => {
                                        return item
                                    }
                                    )}</b>
                                </div>)}
                                {(Array.isArray(location.state.target_preview?.district_ids) && location.state.target_preview?.district_ids?.length > 0) && <div>
                                    {<label className="text-slate-500">Districts : </label>}
                                    <b> {location.state.target_preview.district_ids.map((item, i) => {
                                        return item
                                    }
                                    )}</b>
                                </div>}
                                {(Array.isArray(location.state.target_preview?.ex_districts) && location.state.target_preview?.ex_districts?.length > 0) && <div>
                                    {<label className="text-slate-500">Excluded Districts : </label>}
                                    <b> {location.state.target_preview.ex_districts.map((item, i) => {
                                        return item
                                    }
                                    )}</b>
                                </div>}
                                {(Array.isArray(location.state.target_preview?.mandal_ids) && location.state.target_preview.mandal_ids?.length > 0) && <div>
                                    {<label className="text-slate-500">Mandals : </label>}
                                    <b> {location.state.target_preview.mandal_ids.map((item, i) => {
                                        return item
                                    }
                                    )}</b>
                                </div>}
                                {(Array.isArray(location.state.target_preview?.constituencies) && location.state.target_preview?.constituencies.length > 0) && <div>
                                    {location.state.target_preview?.exclude ? <label className="text-slate-500">Excluded Constituencies : </label> : <label className="text-slate-500">Constituencies : </label>}
                                    <b> {location.state.target_preview.constituencies.map((item, i) => {
                                    return item
                                }
                                )}</b>
                                </div>}
                                {(Array.isArray(location.state.target_preview?.ex_mandals) && location.state.target_preview?.ex_mandals?.length > 0) && <div>
                                    {<label className="text-slate-500">Excluded Mandals : </label>}
                                    <b>{location.state.target_preview.ex_mandals.map((item, i) => {
                                        return item
                                    }
                                    )}</b>
                                </div>}
                                {(Array.isArray(location.state.target_preview?.village_ids) && location.state.target_preview?.village_ids?.length > 0) && <div>
                                    {<label className="text-slate-500">villages : </label>}
                                    <b> {location.state.target_preview.village_ids.map((item, i) => {
                                        return item
                                    }
                                    )}</b>
                                </div>}
                                {(Array.isArray(location.state.target_preview?.ex_villages) && location.state.target_preview?.ex_villages?.length > 0) && <div>
                                    {<label className="text-slate-500">Excluded villages : </label>}
                                    <b> {location.state.target_preview.ex_villages.map((item, i) => {
                                        return item
                                    }
                                    )}</b>
                                </div>}
                                </> : null}
                                {<div>
                                    {<label className="text-slate-500">App Category : </label>}
                                    {(Array.isArray(location.state.target_preview?.app) && location.state.target_preview?.app?.length > 0) ? location.state.target_preview.app.map((item, i) => {

                                        return item
                                    }
                                    ) : < b>{"  "} -</ b>}
                                </div>}
                                {(Array.isArray(location.state.target_preview?.minspend) && location.state.target_preview?.minspend?.length > 0) && <div>
                                    {<label className="text-slate-500">Minimum Spend : </label>}
                                    <b> {location.state.target_preview.minspend.map((item, i) => {

                                        return item
                                    }
                                    )}</b>
                                </div>}
                                {<div>
                                    {location.state.target_preview?.min_age > 0 ? <p><label className="text-slate-500">Min Age</label> : {location.state.target_preview?.min_age}</p> : < b>{"  "} -</ b>}
                                    {location.state.target_preview?.max_age > 0 ? <p><label className="text-slate-500">Max Age</label> : {location.state.target_preview?.max_age}</p> : < b>{"  "} -</ b>}
                                    {location.state.target_preview?.os !== '' ? <p><label className="text-slate-500">OS</label> : {location.state.target_preview?.os}</p> : < b>{"  "} -</ b>}
                                    {location.state.target_preview?.android_version !== '' ? <p><label className="text-slate-500">Android Version</label> : {location.state.target_preview?.android_version}</p> : null}
                                    {location.state.target_preview?.ios_version !== '' ? <p><label className="text-slate-500">IOS Version</label> : {location.state.target_preview?.ios_version}</p> : null}
                                    {location.state.target_preview?.gender !== null ? <p><label className="text-slate-500">Gender</label> : {location.state.target_preview?.gender} </p> : < b>{"  "} -</ b>}
                                </div>}
                            </section>}
                            <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6 className="mb-2">Budget</h6>
                                {location.state.start.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">CPC Price : </label>
                                    {location.state.start.campaign_type === "CPC" && formik.values.cpc_price > 0 ? <span>{formik.values.cpc_price}</span> : "-"}
                                </div>}

                                {location.state.start.campaign_type === "CPD" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">CPD Price : </label>
                                    {location.state.creatselect?.cpd > 0 ? <b>{location.state.creatselect?.cpd}</b> : "-"}
                                </div>}

                                {location.state.start.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">CPM Price : </label>
                                    {location.state.start.campaign_type === "CPM" && formik.values.cpm > 0 ? <span>{formik.values.cpm}</span> : "-"}
                                </div>}

                                {location.state.start.campaign_type !== "CPD" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Daily Budget : </label>
                                    {formik.values.daily_budget > 0 ? <span>{formik.values.daily_budget}</span> : "-"}
                                </div>}

                                {location.state.start.campaign_type !== "CPD" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Total Budget : </label>
                                    {formik.values.total_budget > 0 ? <span>{formik.values.total_budget}</span> : "-"}
                                </div>}

                                {location.state.start.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Daily Click Cap : </label>
                                    {location.state.start.campaign_type === "CPC" && formik.values.daily_click_cap > 0 ? <span>{formik.values.daily_click_cap}</span> : "-"}
                                </div>}

                                {location.state.start.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Daily Impression Cap : </label>
                                    {location.state.start.campaign_type === "CPM" && formik.values.daily_imp_cap > 0 ? <span>{formik.values.daily_imp_cap}</span> : "-"}
                                </div>}

                                {location.state.start.campaign_type === "CPC" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Total Click Cap : </label>
                                    {location.state.start.campaign_type === "CPC" && formik.values.tot_click_cap > 0 ? <span>{formik.values.tot_click_cap}</span> : "-"}
                                </div>}

                                {location.state.start.campaign_type === "CPM" && <div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Total Impression Cap : </label>
                                    {location.state.start.campaign_type === "CPM" && formik.values.tot_imp_cap > 0 ? <span>{formik.values.tot_imp_cap}</span> : "-"}
                                </div>}

                            </section>
                            <section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6 className="mb-2">Date</h6>
                                {!isBrandAd ? <>{<div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Start Date :</label>
                                    <span>{((location.state.start.campaign_type === "CPD" && formik.values.start) || (location.state.start.campaign_type !== "CPD" && formik.values.start_date)) ? location.state.start.campaign_type === 'CPD' ? DatetoTimestamp(formik.values.start) : DatetoTimestamp(formik.values.start_date) : "-"}</span>
                                </div>}
                                {<div className="flex justify-between mb-2">
                                    <label className="text-slate-500">End Date :</label>
                                    <span>{((location.state.start.campaign_type === "CPD" && formik.values.start) || (location.state.start.campaign_type !== "CPD" && formik.values.end_date)) ? location.state.start.campaign_type !== 'CPD' ? DatetoTimestamp(formik.values.end_date) : End_date_cpd(formik.values.start) : "-"}</span>
                                </div>}</>:
                                <>
                                {<div className="flex justify-between mb-2">
                                    <label className="text-slate-500">Start Date :</label>
                                    <span>{((location.state.start.campaign_type === "CPD" && formik.values.start_date)) ?  DatetoTimestamp(formik.values.start_date) : "-"}</span>
                                </div>}
                                {<div className="flex justify-between mb-2">
                                    <label className="text-slate-500">End Date :</label>
                                    <span>{((location.state.start.campaign_type === "CPD" && formik.values.end_date)) ? DatetoTimestamp(formik.values.end_date)  : "-"}</span>
                                </div>}
                                </>
                                }
                                {location.state.start.campaign_type !== 'CPD' && datelist.length !== 0 ? <div className="flex justify-between mb-2" style={{"display": "block"}}>
                                    <label className="text-slate-500" >Day Time Slots :</label>
                                    {datelist.length !== 0 ? <>{(datelist.length > 0 ? datelist.map((item, i) => (<p key={i}> {DatetoTimestamp(item.sdate)} {<br />}  {DatetoTimestamp(item.edate)}</p>)) : null)}</> : <div>None</div>
                                    }{sameday && !plusdisable && <p> Till End Date</p>}</div> : null}

                            </section>

                            {<section className="bg-slate-50 py-4 px-6 rounded-lg">
                                <h6>Create Select</h6>
                                {location.state?.creatselect_preview?.ad_code !== '' && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500">Ad Code :</label> {location.state?.creatselect_preview?.ad_code}</div>}
                                {location.state?.creatselect_preview?.line_item_code !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500">Line Item Code :</label> {location.state?.creatselect_preview?.line_item_code}</div>}
                                {location.state?.creatselect_preview?.dfp_creative_ids && type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP Creative Ids :</label> {location.state?.creatselect_preview?.dfp_creative_ids?.split(',')?.map(item => <>{item}<br /></>)}</div> : null}
                                {location.state?.creatselect_preview?.post_type !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Post Type :</label> {location.state?.creatselect_preview?.post_type}</div>}
                                {location.state?.creatselect_preview?.news_type !== null && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> News Type :</label> {location.state?.creatselect_preview?.news_type}</div>}
                                {location.state?.creatselect_preview?.dfp_backfill_ad_type && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Dfp Backfill Ad Type :</label> {location.state?.creatselect_preview?.dfp_backfill_ad_type}</div>}
                                {location.state?.creatselect_preview?.slotuuid && location.state?.type === "DFP" && <div className="flex justify-between mb-2"><label className="text-slate-500"> Slot Id :</label> {location.state?.creatselect_preview?.slotuuid}</div>}
                                {location.state?.creatselect_preview?.banner_size?.length && location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500"> Banner Size :</label> {location.state?.creatselect_preview?.banner_size?.join(',')}</div> : null}
                                {<div className="flex justify-between mb-2"><label className="text-slate-500">Creative Type  :</label> {location.state?.creatselect_preview?.creative_type !== '' ? location.state?.creatselect_preview?.creative_type : "-"}</div>}
                                {location.state?.creatselect_preview?.frequency_cap > 0 && <div className="flex justify-between mb-2"><label className="text-slate-500">Frequency :</label>  {location.state?.creatselect_preview?.frequency_cap}</div>}
                                {location.state?.creatselect_preview?.frequency_cap_type !== '' && location.state?.creatselect_preview?.positiontype === "rotation" && <div className="flex justify-between mb-2"><label className="text-slate-500">Frequency Cap Type :</label>  {location.state?.creatselect_preview?.frequency_cap_type}</div>}
                                <div className="flex justify-between mb-2"><label className="text-slate-500">Position : </label>{location.state?.creatselect_preview?.position}</div>
                                {location.state?.creatselect_preview?.positiontype !== '' && <div className="flex justify-between mb-2"><label className="text-slate-500">Position Type :</label> {location.state?.creatselect_preview?.positiontype}</div>}
                                {location.state?.creatselect_preview?.positiontype === 'rotation' && location.state?.creatselect_preview?.action_type !== null && <div className="flex justify-between mb-2"><label className="text-slate-500">Action type :</label> {location.state?.creatselect_preview?.action_type}</div>}
                                {localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.salesperson ? <div className="flex justify-between mb-2"><label className="text-slate-500">Priority :</label> {+location.state?.creatselect_preview?.priority ? +location.state?.creatselect_preview?.priority : < b>{" "} -</ b>}</div> : null}
                                {location.state?.type !== "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">Encryption  :</label> {location.state?.creatselect_preview?.encryption ? 'True' : 'False'}</div> : null}
                                {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">Hidden  :</label> {location.state?.creatselect_preview?.dfp_hidden ? 'True' : 'False'}</div> : null}
                                {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP IMA  :</label> {location.state?.creatselect_preview?.dfp_ima ? 'True' : 'False'}</div> : null}
                                {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP PGDEAL  :</label> {location.state?.creatselect_preview?.dfp_pgdeal ? 'True' : 'False'}</div> : null}
                                {location.state?.type === "DFP" ? <div className="flex justify-between mb-2"><label className="text-slate-500">DFP IMA Obstacle :</label> {location.state?.creatselect_preview?.dfp_ima_obs ? 'True' : 'False'}</div> : null}
                            </section>}
                            {location.state.discount_obj && typeofcamp === "CPD" ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6>Discount</h6>
                            {location.state.discount_obj.discount_no ? <div className="flex justify-between mb-2"><label className="text-slate-500">Discount :</label> {`${location.state.discount_obj.discsign ? "+" : "-"} ${location.state.discount_obj.discount_no} %`}</div> : null}
                            {location.state.discount_obj.actualPrice ? <div className="flex justify-between mb-2"><label className="text-slate-500">Actual Price  :</label> {location.state.discount_obj.actualPrice}</div> : null}
                            {location.state.discount_obj.discountPrice ? <div className="flex justify-between mb-2"><label className="text-slate-500">After Discount  :</label> {location.state.discount_obj.discountPrice}</div> : null}
                            </section> : null}
                            {typeofcamp === "CPC" && discoutnEnab ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6>Discount</h6>
                            {+formik.values.cpc_price !== +config.ACTUALCPC ? <div className="flex justify-between mb-2"><label className="text-slate-500">Discount :</label> {`${(+config.ACTUALCPC - +formik.values.cpc_price) > 0 ? "-" : "+"} ${Math.abs((100/config.ACTUALCPC)*(config.ACTUALCPC - +formik.values.cpc_price)).toFixed(2)} %`}</div> : null}
                            {<div className="flex justify-between mb-2"><label className="text-slate-500">Actual Price  :</label> {config.ACTUALCPC} </div>}
                            {formik.values.cpc_price ? <div className="flex justify-between mb-2"><label className="text-slate-500">After Discount  :</label> {formik.values.cpc_price}</div> : null}
                            </section> : null}
                            {typeofcamp === "CPM" && discoutnEnab ? <section className="bg-slate-50 py-4 px-6 rounded-lg">
                            <h6>Discount</h6>
                            {+formik.values.cpm !== +config.ACTUALCPM ? <div className="flex justify-between mb-2"><label className="text-slate-500">Discount :</label> {`${(+config.ACTUALCPM - +formik.values.cpm) > 0 ? "-" : "+"} ${Math.abs((100/config.ACTUALCPM)*(config.ACTUALCPM - +formik.values.cpm)).toFixed(2)} %`}</div> : null}
                            {<div className="flex justify-between mb-2"><label className="text-slate-500">Actual Price  :</label> {config.ACTUALCPM} </div>}
                            {formik.values.cpm ? <div className="flex justify-between mb-2"><label className="text-slate-500">After Discount  :</label> {formik.values.cpm}</div> : null}
                            </section> : null}
                        </div>
                        {<section className="basis-5/12 rounded-2xl overflow-hidden">
                            {<> {(location.state?.creatselect_preview?.creatives_preview?.length > 0 ?
                                <Swiper
                                    spaceBetween={0}
                                    pagination={true}
                                    navigation={true}
                                    modules={[Navigation, Pagination]}
                                    className="mySwiper"
                                    style={{ width: "460px" }}>
                                    {location.state?.creatselect_preview?.creatives_preview?.map((campPreview) => <SwiperSlide><campCreativeContext3.Provider value={{ campPreview }}><PreviewFrameEdit showPreview={true} /></campCreativeContext3.Provider></SwiperSlide>)}</Swiper> : <>
                                    <section className="preview-mobile">
                                        <div className="preview-inner">
                                            <div className="preview-full-image">
                                                <div className='mt-60 ml-1 preview-text'>Preview of your creative will be shown here once after you select your creative</div>
                                            </div>
                                        </div></section>
                                </>)} </>}
                        </section>}
                    </section>
                </div>
                <div>
                    <form onSubmit={formik.handleSubmit} className="contents">
                        <Stepper
                            steps={steps}
                            activeStep={2} />

                        <fieldset >
                            <legend className="">Dates</legend>

                            <section>
                                {!isBrandAd ? <>{
                                    typeofcamp !== "CPD" ?
                                        <div>
                                            <div className="row mb-3">
                                                <div className="col1">
                                                    <label htmlFor="" className="form-label">Start Date</label>
                                                    <span className="text-red-600">*</span>
                                                    <input type="datetime-local" className="form-control" placeholder="" aria-label="" name="start_date"
                                                        value={formik.values.start_date}
                                                        onBlur={formik.handleBlur}
                                                        onChange={(e) => { formik.handleChange(e); formik.values.start_date = e.target.value; DailyBudgetCalculation(formik.values.total_budget); if (e.target.value < currentDate) { formik.setFieldValue("start_date", "") } }} min={currentDate} disabled={location?.state?.status === 2}/>
                                                    {formik.errors.start_date && formik.touched.start_date ? <div className="text-red-600">{formik.errors.start_date}</div> : null}
                                                </div>
                                                <div className="col1">
                                                    <label htmlFor="" className="form-label">End Date</label>
                                                    <span className="text-red-600">*</span>
                                                    <input type="datetime-local" className="form-control" placeholder="" aria-label="" name="end_date"
                                                        value={formik.values.end_date}
                                                        onBlur={formik.handleBlur}
                                                        onChange={(e) => { formik.handleChange(e); formik.values.end_date = e.target.value; DailyBudgetCalculation(formik.values.total_budget) }} min={currentDate} />
                                                    {formik.errors.end_date && formik.touched.end_date ? <div className="text-red-600">{formik.errors.end_date}</div> : null}

                                                </div>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" id="flexCheckDefault"
                                                    checked={check}
                                                    onChange={() => setCheck(!check)
                                                    }
                                                />
                                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                                    Set prefer day or time
                                                </label>
                                            </div>
                                            {check ?
                                                datelist.map((list, index) => {

                                                    return (
                                                        <div key={index} className="row">
                                                            <div className="col2">
                                                                <label htmlFor="" className="form-label">Start Date & Time </label>
                                                                <input type="datetime-local" className="form-control" placeholder="" aria-label="" name="sdate" value={datelist[index].sdate} onChange={(e) => {
                                                                    handleDateChange(e, index);
                                                                    CheckDate(index)
                                                                }}
                                                                />
                                                                {derror ? <div className="text-red-600">{datelist[index].sderror}</div> : null}
                                                            </div>
                                                            <div className="col2">
                                                                <label htmlFor="" className="form-label">End Date & Time </label>
                                                                <input type="datetime-local" className="form-control" placeholder="" aria-label="" name="edate" value={datelist[index].edate} onChange={(e) => {
                                                                    handleDateChange(e, index);
                                                                    CheckDate(index)
                                                                    setSameday(SameDay(datelist[index].sdate, datelist[index].edate))
                                                                    if (!setSameday(SameDay(datelist[index].sdate, datelist[index].edate))) {
                                                                        setPlusdisable(true)
                                                                    }

                                                                }} />
                                                                {derror1 ? <div className="text-red-600">{datelist[index].ederror}</div> : null}
                                                            </div><div className="col3 text-danger mt-8">
                                                                <sl-icon library="lucide" name="x-circle" type="button" size="medium" onClick={(e) => { handleRemove(index) }}></sl-icon>
                                                                {/* <button type="button" className="btn btn-outline-danger" onClick={(e) => { handleRemove(index) }}>Remove</button> */}
                                                            </div>
                                                            {

                                                                sameday && datelist.length < 2 ? <div className="form-check ml-3 pt-2 pb-2">
                                                                    <input className="form-check-input" type="checkbox" id="flexCheckDefault"
                                                                        checked={sameday && !plusdisable}
                                                                        onChange={() => {
                                                                            setPlusdisable(!plusdisable)
                                                                        }}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                        Repeat till end Date
                                                                    </label>
                                                                </div> : null
                                                            }
                                                            {datelist.length - 1 === index && datelist.length < 30 && (
                                                                <div className="row mb-3 align-items-end">
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                                )
                                                : null
                                            }
                                            {
                                                (check && plusdisable) ? <button type="button" className="btn"><i className="bi bi-plus-circle-fill text-primary fs-2" onClick={() => { handleClick() }}></i></button> : null

                                            }
                                        </div>
                                        :
                                        <div className="col">
                                            <label htmlFor="" className="form-label">Start Date</label>
                                            <span className="text-red-600">*</span>
                                            <div className="d-flex gap-2">
                                            <input type="datetime-local" className="form-control" placeholder="" aria-label="" name="start"
                                                value={formik.values.start}
                                                onBlur={formik.handleBlur}
                                                disabled={location?.state?.status === 2}
                                                onChange={formik.handleChange} min={currentDate}/>
                                                <div className="d-flex gap-1 items-center">
                                                    <input
                                                        type="checkbox"
                                                        name="ser_24_hrs"
                                                        id="ser_24_hrs"
                                                        checked={formik.values.ser_24_hrs}
                                                        onBlur={formik.handleBlur}
                                                        onChange={formik.handleChange}
                                                        disabled={location?.state?.status === 2}
                                                    />
                                                    <label htmlFor="ser_24_hrs" className="whitespace-nowrap text-xl font-semibold">Serve 24 hours</label>
                                                </div>
                                            </div>
                                            {formik.errors.start && formik.touched.start ? <div className="text-red-600">{formik.errors.start}</div> : null}
                                        </div>
                                }</> : 
                                
                                <>
                                <div>
                                            <div className="row mb-3">
                                                <div className="col1">
                                                    <label htmlFor="" className="form-label">Start Date</label>
                                                    <span className="text-red-600">*</span>
                                                    <input type="datetime-local" className="form-control" placeholder="" aria-label="" name="start_date"
                                                        value={formik.values.start_date}
                                                        onBlur={formik.handleBlur}
                                                        onChange={(e) => { formik.handleChange(e); formik.values.start_date = e.target.value;  if (e.target.value < currentDate) { formik.setFieldValue("start_date", "") } }} min={currentDate}  disabled={location?.state?.status === 2}/>
                                                    {formik.errors.start_date && formik.touched.start_date ? <div className="text-red-600">{formik.errors.start_date}</div> : null}
                                                </div>
                                                <div className="col1">
                                                    <label htmlFor="" className="form-label">End Date</label>
                                                    <span className="text-red-600">*</span>
                                                    <input type="datetime-local" className="form-control" placeholder="" aria-label="" name="end_date"
                                                        value={formik.values.end_date}
                                                        onBlur={formik.handleBlur}
                                                        onChange={(e) => { formik.handleChange(e); formik.values.end_date = e.target.value; }} min={currentDate} />
                                                    {formik.errors.end_date && formik.touched.end_date ? <div className="text-red-600">{formik.errors.end_date}</div> : null}

                                                </div>
                                            </div>
                                        </div>
                                </>}

                            </section>

                        </fieldset>

                        <fieldset >
                        {typeofcamp !== "CPD" &&<legend className="">Budget</legend>}
                            <section>
                                {
                                    (typeofcamp === "CPD") ?
                                        null :
                                        <div>
                                            <div className="col">
                                                <label htmlFor="" className="form-label">Total Budget</label>
                                                <span className="text-red-600">*</span>
                                                <input type="number" className="form-control" placeholder="Total Budget" aria-label="" name="total_budget"
                                                    value={formik.values.total_budget}
                                                    onBlur={formik.handleBlur}
                                                    onChange={(e) => {
                                                        formik.handleChange(e);
                                                        DailyBudgetCalculation(e.target.value)

                                                    }} />
                                                {formik.errors.total_budget && formik.touched.total_budget ? <div className="text-red-600">{formik.errors.total_budget}</div> : null}
                                            </div>
                                            <div className="col">
                                                <label htmlFor="" className="form-label">Daily Budget</label>
                                                <span className="text-red-600">*</span>
                                                <input type="number" className="form-control" placeholder="Daily Budget" aria-label="" name="daily_budget"
                                                    value={formik.values.daily_budget}
                                                    onBlur={formik.handleBlur}
                                                    onChange={formik.handleChange} />
                                                {formik.errors.daily_budget && formik.touched.daily_budget ? <div className="text-red-600">{formik.errors.daily_budget}</div> : null}
                                            </div>
                                        </div>
                                }

                                {(typeofcamp === "CPC") ?<>
                                <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">CPC Price</label>
                                            <span className="text-red-600">*</span>
                                            <input type="number" className="form-control" id="exampleFormControlInput1" name="cpc_price" placeholder="CPC Price"
                                                value={config.ACTUALCPC}
                                                onBlur={formik.handleBlur}
                                                disabled={true} />
                                        </div>
                                        <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Enable Discount %</label>
                                        <input type = "checkbox" checked = {discoutnEnab} onChange={() => {setDiscountEnab(!discoutnEnab);
                                        if (!discoutnEnab === false) {
                                            formik.values.tot_click_cap = parseInt((formik.values.total_budget) / +config.ACTUALCPC)
                                            formik.values.daily_click_cap = parseInt((formik.values.daily_budget) / +config.ACTUALCPC)
                                            formik.setFieldValue("tot_click_cap", parseInt((formik.values.total_budget) / +config.ACTUALCPC))
                                            formik.setFieldValue("daily_click_cap", parseInt((formik.values.daily_budget) / +config.ACTUALCPC))
                                            formik.setFieldValue('cpc_price',+config.ACTUALCPC)
                                        }
                                        }}
                                        disabled={location?.state?.status === 2}
                                        />
                                        </div>
                                        {discoutnEnab && formik.values.cpc_price !== '' ?<div className="mb-3">discount given {(config.ACTUALCPC - formik.values.cpc_price) > 0 ?  '(-)' : '(+)'} {Math.abs((100/config.ACTUALCPC)*(config.ACTUALCPC - formik.values.cpc_price)).toFixed(2)}%</div> : null}

                                    {discoutnEnab ? <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Discount CPC Price</label>
                                            <span className="text-red-600">*</span>
                                            <input type="number" className="form-control" id="exampleFormControlInput1" name="cpc_price" placeholder="CPC Price"
                                                value={formik.values.cpc_price}
                                                onBlur={formik.handleBlur}
                                                onChange={(e) => {
                                                    formik.handleChange(e);
                                                    formik.values.cpc_price = e.target.value;
                                                    if (formik.values.cpc_price !== "") {
                                                        formik.values.tot_click_cap = parseInt((formik.values.total_budget) / e.target.value)
                                                        formik.values.daily_click_cap = parseInt((formik.values.daily_budget) / e.target.value)
                                                        formik.setFieldValue("tot_click_cap", parseInt((formik.values.total_budget) / e.target.value))
                                                        formik.setFieldValue("daily_click_cap", parseInt((formik.values.daily_budget) / e.target.value))
                                                    }
                                                    if (e.target.value === "" || e.target.value === "0") {
                                                        formik.values.tot_click_cap = parseInt((formik.values.total_budget) / config.ACTUALCPC)
                                                        formik.values.daily_click_cap = parseInt((formik.values.daily_budget) / config.ACTUALCPC)
                                                        formik.setFieldValue("tot_click_cap", parseInt((formik.values.total_budget) / config.ACTUALCPC))
                                                        formik.setFieldValue("daily_click_cap", parseInt((formik.values.daily_budget) / config.ACTUALCPC))
                                                    }
                                                }}
                                                disabled={location?.state?.status === 2}
                                               />
                                            {formik.errors.cpc_price && formik.touched.cpc_price ? <div className="text-red-600">{formik.errors.cpc_price}</div> : null}

                                        </div> : null}
                                    </> : null}
                                <div>


                                    {(typeofcamp === "CPM") ?<>
                                    <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">CPM Price</label>
                                            <span className="text-red-600">*</span>
                                            <input type="number" className="form-control" id="exampleFormControlInput1" name="cpm" placeholder="CPM Price"
                                                value={config.ACTUALCPM}
                                                onBlur={formik.handleBlur}
                                                disabled={true} />
                                        </div>
                                        <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Enable Discount %</label>
                                        <input type = "checkbox" checked = {discoutnEnab} onChange={() => {setDiscountEnab(!discoutnEnab);
                                        if (!discoutnEnab === false) {
                                            formik.values.tot_imp_cap = parseInt((formik.values.total_budget * 1000) / +config.ACTUALCPM)
                                            formik.values.daily_imp_cap = parseInt((formik.values.daily_budget * 1000) / +config.ACTUALCPM)
                                            formik.setFieldValue("tot_imp_cap", parseInt((formik.values.total_budget * 1000) / +config.ACTUALCPM))
                                            formik.setFieldValue("daily_imp_cap", parseInt((formik.values.daily_budget * 1000) / +config.ACTUALCPM))
                                            formik.setFieldValue('cpm',+config.ACTUALCPM)
                                        }
                                        }}
                                        disabled={location?.state?.status === 2}/>
                                        </div>
                                        {discoutnEnab && formik.values.cpm !== '' ?<div className="mb-3">discount given {(config.ACTUALCPM - formik.values.cpm) > 0 ?  '(-)' : '(+)'} {Math.abs((100/config.ACTUALCPM)*(config.ACTUALCPM - formik.values.cpm)).toFixed(2)}%</div> : null}
                                        {discoutnEnab ? <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Discount CPM Price</label>
                                            <span className="text-red-600">*</span>
                                            <input type="number" className="form-control" id="exampleFormControlInput1" name="cpm" placeholder="CPM Price"
                                                value={formik.values.cpm}
                                                onBlur={formik.handleBlur}
                                                onChange={(e) => {
                                                    formik.handleChange(e);
                                                    formik.values.cpm = e.target.value;
                                                    if (formik.values.cpm !== "") {
                                                        formik.values.tot_imp_cap = parseInt((formik.values.total_budget * 1000) / e.target.value)
                                                        formik.values.daily_imp_cap = parseInt((formik.values.daily_budget * 1000) / e.target.value)
                                                        formik.setFieldValue("tot_imp_cap", parseInt((formik.values.total_budget * 1000) / e.target.value))
                                                        formik.setFieldValue("daily_imp_cap", parseInt((formik.values.daily_budget * 1000) / e.target.value))
                                                    }
                                                    if (e.target.value === "" || e.target.value === "0") {
                                                        formik.values.tot_imp_cap = parseInt((formik.values.total_budget * 1000) / config.ACTUALCPM)
                                                        formik.values.daily_imp_cap = parseInt((formik.values.daily_budget * 1000) / config.ACTUALCPM)
                                                        formik.setFieldValue("tot_imp_cap", parseInt((formik.values.total_budget * 1000) / config.ACTUALCPM))
                                                        formik.setFieldValue("daily_imp_cap", parseInt((formik.values.daily_budget * 1000) / config.ACTUALCPM))
                                                    }
                                                }} 
                                                disabled={location?.state?.status === 2}/>
                                            {formik.errors.cpm && formik.touched.cpm ? <div className="text-red-600">{formik.errors.cpm}</div> : null}

                                        </div> : null}
                                        </> : null}
                                        

                                    <div className="row mb-3">
                                        {typeofcamp === "CPM" ? <div className="col">
                                            <label htmlFor="" className="form-label">Total Impression CAP</label>
                                            <input type="number" className="form-control" placeholder="Total Impression CAP" aria-label="" name="tot_imp_cap"
                                                value={formik.values.tot_imp_cap}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                            />
                                            {formik.errors.tot_imp_cap && formik.touched.tot_imp_cap ? <div className="text-red-600">{formik.errors.tot_imp_cap}</div> : null}

                                        </div> : null}


                                        {typeofcamp === "CPC" ? <div className="col">
                                            <label htmlFor="" className="form-label">Total Click CAP</label>
                                            <input type="number" className="form-control" placeholder="Total Click CAP" aria-label="" name="tot_click_cap"
                                                value={formik.values.tot_click_cap}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                            />
                                            {formik.errors.tot_click_cap && formik.touched.tot_click_cap ? <div className="text-red-600">{formik.errors.tot_click_cap}</div> : null}


                                        </div> : null}

                                    </div>
                                    

                                    <div className="row mb-3">
                                        {typeofcamp === "CPM" ? <div className="col">
                                            <label htmlFor="" className="form-label">Daily Impression CAP</label>
                                            <input type="number" className="form-control" placeholder="Daily Impression CAP" aria-label="" name="daily_imp_cap"
                                                value={formik.values.daily_imp_cap}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                            />
                                            {formik.errors.daily_imp_cap && formik.touched.daily_imp_cap ? <div className="text-red-600">{formik.errors.daily_imp_cap}</div> : null}

                                        </div> : null}


                                        {typeofcamp === "CPC" ? <div className="col">
                                            <label htmlFor="" className="form-label">Daily Click CAP</label>
                                            <input type="number" className="form-control" placeholder="Daily Click CAP" aria-label="" name="daily_click_cap"
                                                value={formik.values.daily_click_cap}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                            />
                                            {formik.errors.daily_click_cap && formik.touched.daily_click_cap ? <div className="text-red-600">{formik.errors.daily_click_cap}</div> : null}

                                        </div> : null}
                                        
                                    </div>


                                </div>

                            </section>
                        </fieldset>
                        <div className="d-flex justify-between">
                        <SlButton variant="neutral" onClick={() => {
                                let budget = formik.values
                                switch (location.state.start.campaign_type) {
                                    case "CPC":
                                        budget.cpm = 0
                                        break
                                    case "CPM":
                                        budget.cpc_price = 0
                                        break
                                    default:
                                }
                                const dateResult = { start_date: formik.values.start_date, end_date: formik.values.end_date, start: formik.values.start, datelist: datelist, ser_24_hrs: formik.values.ser_24_hrs }
                                const date_budget_preview = { ...(formik.values), datelist, till_date: sameday && !plusdisable } 
                                let discount_obj = null
                                if(typeofcamp === "CPC" && +formik.values.cpc_price !== +config.ACTUALCPC && (+config.ACTUALCPC - +formik.values.cpc_price) > 0){
                                    discount_obj = {discount_no : Math.abs((100/config.ACTUALCPC)*(config.ACTUALCPC - +formik.values.cpc_price)).toFixed(2), actualPrice: config.ACTUALCPC, discountPrice: +formik.values.cpc_price,  discsign: (config.ACTUALCPC - +formik.values.cpc_price) > 0 ? false: true}
                                }
                                else if(typeofcamp === "CPM" && +formik.values.cpm !== +config.ACTUALCPM && (+config.ACTUALCPM - +formik.values.cpm) > 0){
                                    discount_obj = {discount_no : Math.abs((100/config.ACTUALCPM)*(config.ACTUALCPM - +formik.values.cpm)).toFixed(2), actualPrice: config.ACTUALCPM, discountPrice: +formik.values.cpm,  discsign: (config.ACTUALCPM - +formik.values.cpm) > 0 ? false: true}
                                }
                                else
                                    discount_obj = location.state.discount_obj
                                navigate("/home/campaign/target", { state: { ...location.state, budget: budget, date: dateResult, sameday: sameday, plusdisable: plusdisable, date_budget_preview: date_budget_preview, discount_obj } })
                            }}>Back</SlButton>
                            <SlButton type='submit' variant="primary" disabled={derror || derror1}> Next</SlButton>
                        </div>
                    </form>

                </div>
                

            </div>
        </div>
    </>
    )

}

export default Date;